if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function() {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.gallery-block-list').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 500,
                settings: {
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: "<button type='button' class='slick-prev'><img src='m/assets/images/LeftArrow.png'></button>",
                    nextArrow: "<button type='button' class='slick-next'><img src='m/assets/images/RightArrow.png'></button>"
                }
            },
        ]
    });
    $('.gallery-grid__list').slick({
        accessibility: false,
        fade: true,
        dots: true,
        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
                prevArrow: "<button type='button' class='slick-prev'><img src='m/assets/images/LeftArrow.png'></button>",
                nextArrow: "<button type='button' class='slick-next'><img src='m/assets/images/RightArrow.png'></button>"
            }
        }],
    });

    $('.carousel-slider').slick({
        arrows: false,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: true,
        // prevArrow: "<button type='button' class='slick-prev'><img src='m/assets/images/LeftArrow.png'></button>",
        // nextArrow: "<button type='button' class='slick-next'><img src='m/assets/images/RightArrow.png'></button>", 
        responsive: [{
            breakpoint: 600,
            settings: {
                arrows: true,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                adaptiveHeight: true
            }
        }]
    });

    var heightMenu = $('header').height();
    /** Smooth Scroll */
    $('a[href*="#widget-reservation"]').on('click', function(e) {
        e.preventDefault()

        $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top - heightMenu,
            },
            800,
            'linear'
        )
    })
    $('a[href*="#form_id-"]').on('click', function(e) {
        e.preventDefault()

        $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top - heightMenu,
            },
            800,
            'linear'
        )
    })
    console.log(heightMenu);

    $('.gallery').css('margin-top', heightMenu);


})();